'use client'

const items = [
  'Google Calendar', 'Outlook', 'iCloud', 'Gmail', 'Slack', 'Notion',
  'Zoom', 'Google Meet', 'Teams', 'WhatsApp', 'Chrome', 'Safari',
]

export default function Integrations() {
  return (
    <div style={{
      position: 'relative', overflow: 'hidden',
      padding: '24px 0',
      borderTop: '1px solid var(--line)',
      borderBottom: '1px solid var(--line)',
    }}>
      <div style={{
        display: 'flex', gap: 48, width: 'max-content',
        animation: 'avaScrollLogos 40s linear infinite',
      }}>
        {[...items, ...items].map((name, i) => (
          <div key={i} style={{
            fontFamily: 'var(--font-fraunces), serif',
            fontSize: 24, color: 'var(--ink-3)',
            whiteSpace: 'nowrap',
            letterSpacing: -0.3,
            opacity: 0.6,
          }}>{name}</div>
        ))}
      </div>
    </div>
  )
}
